module.exports = __webpack_public_path__ + "img/confirmed.96771d8e.gif";